export default window.ceresStore;
